import { render, staticRenderFns } from "./NewSubAgentPage.vue?vue&type=template&id=41cb8816&scoped=true"
import script from "./NewSubAgentPage.vue?vue&type=script&lang=js"
export * from "./NewSubAgentPage.vue?vue&type=script&lang=js"
import style0 from "./NewSubAgentPage.vue?vue&type=style&index=0&id=41cb8816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cb8816",
  null
  
)

export default component.exports